import { get, getAll } from '@bigyouth/base'

export default {
  name: 'carousel',

  ui: {
    'triggers[]': '[js-carousel-trigger]',
    'els[]': '[js-carousel-el]',
  },

  events: [
    {
      on: 'click',
      target: 'triggers',
      handle (e) {
        get('[js-carousel-trigger].is-active', this.el).classList.remove(
          'is-active',
        )
        e.target.classList.add('is-active')

        getAll('[js-carousel-el]:not(.is-hidden)').forEach((el) => {
          el.classList.add('is-hidding')

          setTimeout(() => {
            el.classList.remove('is-hidding')
            el.classList.add('is-hidden')
          }, 400)
        })

        getAll(`[js-carousel-el][data-pos="${e.target.dataset.pos}"]`).forEach(el => {
          el.classList.add('is-block')

          setTimeout(() => {
            el.classList.remove('is-hidden')
            el.classList.remove('is-block')
          }, 600)
        })
      },
    },
  ],

  componentDidMount () {},
}
